import { PoapList } from "../../domain/poap/Models/PoapList"

export type PoapListLoaderData = { poapList: PoapList }

export const poapListLoader = async () => {
  const poapList = await window.domain.GetPoapListUseCase.execute().catch(console.error)
  if (!poapList) throw new Error("Poap list not found")
  return { poapList } satisfies PoapListLoaderData
}
